import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import WhiteSpace from 'components/WhiteSpace'
import WingBlank from 'components/WingBlank'

export default class Error extends React.Component {
  // constructor (props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }
  render() {
    const { type, msg, traceCode, code, details } = this.props
    if (type === '404') {
      return (
        <WingBlank className={classes.componentsError}>
          <img width='60' src={require('./images/expired.png')} />
          <WhiteSpace size='md' />
          <h3>Page Not Found!</h3>
          <WhiteSpace size='xl' />
          <p>Code: 404</p>
          <WhiteSpace size='xxl' />
        </WingBlank>
      )
    }
    return (
      <WingBlank className={classes.componentsError}>
        <img width='60' src={require('./images/expired.png')} />
        <WhiteSpace size='md' />
        <h3>{msg}</h3>
        {!traceCode && code && <h5>Code: {code}</h5>}
        {traceCode && <h5>traceCode: {traceCode}</h5>}
        {details && <p className='font-14'>{details}</p>}
        <WhiteSpace size='xxl' />
      </WingBlank>
    )
  }
}
